import { createFileRoute, redirect } from '@tanstack/react-router'
import { LIST, restoreFilters } from '@thom/folio-ui/routing/list-filters'
import { Plans } from '@thom/folio-ui/pages/plans'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/plans/')({
	beforeLoad: ({ search, cause, params, context }) => {
		if (cause !== 'enter') return
		const restored = restoreFilters(context.container.listMemory, LIST.PLANS, search)
		if (restored) throw redirect({ to: '/$client/$domain/$slug/plans', params, search: restored })
	},
	component: Plans,
})
